// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const toggleReportsAccordion = () => ({
    type: actions.TOGGLE_TCSM_REPORTS_ACCORDION
});



// WEBPACK FOOTER //
// ./src/tcsm/shared/action-creators/reports-accordion.js